import { render } from "./StageGoalsAndBudget.vue?vue&type=template&id=5355d5b4"
import script from "./StageGoalsAndBudget.vue?vue&type=script&lang=js"
export * from "./StageGoalsAndBudget.vue?vue&type=script&lang=js"

import "./StageGoalsAndBudget.vue?vue&type=style&index=0&id=5355d5b4&lang=scss&scope=true"

import exportComponent from "/data/projects/private_futurelab/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__